import { IconProps } from './types';

export const LinkIcon = (props: IconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 35.992 35.96'>
    <g transform='translate(-0.993 -1.007)'>
      <path
        d='M15,20.586a7.994,7.994,0,0,0,12.055.863l4.8-4.8a7.993,7.993,0,1,0-11.3-11.3L17.8,8.084'
        transform='translate(0.791)'
        fill='none'
        stroke='#fff'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='4'
        {...props}
      />
      <path
        d='M22.186,16.7a7.994,7.994,0,0,0-12.055-.863l-4.8,4.8a7.993,7.993,0,1,0,11.3,11.3L19.372,29.2'
        transform='translate(0 0.691)'
        fill='none'
        stroke='#fff'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='4'
        {...props}
      />
    </g>
  </svg>
);
